export const SET_LOADING = 'setLoading';
export const SET_ALERT = 'setAlert';
export const SET_ALERT_TEXT = 'setAlertText';
